import { useI18n } from '../../hooks/useI18nFormatters';

import { glyph } from '../../theme/glyph';

import { TabAddMenu } from '../../components/sub-navigation/TabAddMenu';

const KEYS = {
  SCRIPT: 'SCRIPT',
};

export function ScriptsAddMenu(props) {
  const { i18n } = useI18n();

  const items = [
    {
      key: KEYS.SCRIPT,
      label: i18n.messageFormatter('script.newScript'),
      icon: glyph.system.homeyscript,
    },
  ];

  function handleAction(key) {
    switch (key) {
      case KEYS.SCRIPT:
        props.onNewScript();
        break;
      default:
        break;
    }
  }

  return (
    <TabAddMenu
      ariaLabel="Scripts Add Menu"
      title={i18n.messageFormatter('header.add')}
      items={items}
      onAction={handleAction}
    />
  );
}
